import styled from '@emotion/styled';

export const LogoContainer = styled.div`
    img {
        height: 60px;
    }
`;
